export default "__VITE_ASSET__BKyokSx3__"